import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceL, spaceS } from '@xingternal/tokens';
import { Meta } from '@xingternal/typography';

export const TextRow = styled(Meta)`
  margin-bottom: ${spaceS};

  @media ${mediaConfined} {
    margin-bottom: ${spaceL};
  }
`;
